import { Component } from '@theme/component';

class AgentSearchComponent extends Component {
  requiredRefs = ['form', 'input', 'mic'];
  #recognition = null;
  #dictationSilenceTimer = null;

  connectedCallback() {
    super.connectedCallback();
    if (window.SpeechRecognition || window.webkitSpeechRecognition) {
      this.refs.mic.hidden = false;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#recognition) this.#recognition.stop();
  }

  handleSubmit(event) {
    event.preventDefault();
    const { input } = this.refs;
    const value = input.value.trim();
    if (!value) return;

    const overlay = document.querySelector('agent-overlay-component');
    if (overlay && typeof (/** @type {any} */ (overlay).openWithMessage) === 'function') {
      /** @type {any} */ (overlay).openWithMessage(value);
      input.value = '';
    } else {
      console.warn('agent-overlay-component not found on the page.');
    }
  }

  toggleDictation() {
    if (this.#recognition) {
      this.#recognition.stop();
      return;
    }
    this.#startDictation();
  }

  #startDictation() {
    const SpeechRecognitionCtor = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognitionCtor) return;
    const { input, mic } = this.refs;
    const recognition = new SpeechRecognitionCtor();
    this.#recognition = recognition;
    if (document.documentElement.lang) recognition.lang = document.documentElement.lang;
    recognition.interimResults = true;
    recognition.continuous = true;
    let autoSendOnEnd = false;
    const originalPlaceholder = input.placeholder;
    mic.classList.add('agent-search__mic--listening');
    mic.setAttribute('aria-label', 'Stop and use this');
    mic.setAttribute('title', 'Stop and use this');
    input.placeholder = 'Listening…';
    recognition.addEventListener('result', (event) => {
      let transcript = '';
      for (let i = 0; i < event.results.length; i++) {
        transcript += event.results[i][0].transcript;
      }
      input.value = transcript;
      clearTimeout(this.#dictationSilenceTimer);
      this.#dictationSilenceTimer = setTimeout(() => {
        autoSendOnEnd = true;
        recognition.stop();
      }, 3000);
    });
    recognition.addEventListener('error', (event) => {
      console.error('Agent search dictation failed:', event.error);
    });
    recognition.addEventListener('end', () => {
      clearTimeout(this.#dictationSilenceTimer);
      this.#recognition = null;
      mic.classList.remove('agent-search__mic--listening');
      mic.setAttribute('aria-label', 'Speak your message');
      mic.setAttribute('title', 'Speak your message');
      input.placeholder = originalPlaceholder;
      if (autoSendOnEnd && input.value.trim()) {
        this.handleSubmit({ preventDefault: () => {} });
      } else {
        input.focus();
      }
    });
    recognition.start();
  }
}

if (!customElements.get('agent-search-component')) {
  customElements.define('agent-search-component', AgentSearchComponent);
}
